import {keyCodes} from '../../../../../utility/js/utils';
export default class Payment {
    selectors = {
        paymentWarning: '.payment__warning',
        PlaceOrderBtn: '#placeOrderButton',
        warningMessage: '.warning-message',
        errorMsgBox: '.errorMsgBox.error:not(.hidden) ',
        toolTip: '.hintTip',
    };

    elements = {
        paymentWarning: null,
        PlaceOrderBtn: null,
        warningMessage: null,
        errorMsgBox: null,
        toolTip: null,
    };

    variables = {
        isPaymentWarningVisible: '',
    };

    constructor() {
        this.setElements();
        this.eventListeners();
        this.handleScroll();
        if (window.adobeDataLayer && this.elements.errorMsgBox) {
            this.loadPaymentError();
        }
        this.handleTooltipToggle();
    }

    handleTooltipToggle() {
        if (this.elements.toolTip) {
            const toolTipButt = this.elements.toolTip.querySelector('button');
            const message = toolTipButt?.getAttribute('data-toggletip-content');
            const toolTipText = this.elements.toolTip.querySelector('.hintTipText');

            const addMessage = () => {
                if (toolTipText) {
                    toolTipText.innerHTML = message;
                    toolTipText.classList.remove('hidden');
                }
            };

            const removeMessage = () => {
                if (toolTipText && !toolTipText.classList.contains('hidden')) {
                    toolTipText.classList.add('hidden');
                    toolTipText.innerHTML = '';
                }
            };

            toolTipButt?.addEventListener('mouseover', addMessage);
            toolTipButt?.addEventListener('mouseout', removeMessage);
            toolTipButt?.addEventListener('focus', addMessage);
            toolTipButt?.addEventListener('focusout', removeMessage);
            document.addEventListener('keydown', function (e) {
                if (e.keyCode === keyCodes.ESCAPE) {
                    removeMessage();
                    e.preventDefault();
                    e.stopPropagation();
                }
            });
        }
    }

    setElements() {
        this.elements.paymentWarning = document.querySelector(this.selectors.paymentWarning);
        this.elements.PlaceOrderBtn = document.querySelector(this.selectors.PlaceOrderBtn);
        this.elements.warningMessage = document.querySelector(this.selectors.warningMessage);
        this.elements.errorMsgBox = document.querySelector(this.selectors.errorMsgBox);
        this.elements.toolTip = document.querySelector(this.selectors.toolTip);
    }

    eventListeners() {
        window.adobeDataLayer && this.elements.PlaceOrderBtn?.addEventListener('click', this.PaymentError);
    }

    handleScroll() {
        if (this.elements.paymentWarning) {
            const paymentWarningStyle =
                this.elements.paymentWarning && window.getComputedStyle(this.elements.paymentWarning);
            const paymentWarningOffsetTop = this.elements.paymentWarning?.offsetTop;
            this.variables.isPaymentWarningVisible = paymentWarningStyle.display !== 'none';

            if (this.variables.isPaymentWarningVisible) {
                window.scrollTo({
                    top: paymentWarningOffsetTop,
                    behavior: 'smooth',
                });
            }
        }
    }

    PaymentError = () => {
        const pushError = () => {
            if (!this.variables.isPaymentWarningVisible && this.elements.warningMessage.textContent) {
                UX.adobeDigitalData.eCommerce.PaymentErrors(this.elements.warningMessage.textContent);
            }
        };

        UX.utils.mutationObserver('.warning-message', {childList: true, subtree: true}, pushError);
    };

    loadPaymentError = () => {
        const navigationEntries = window.performance.getEntriesByType('navigation');
        if (navigationEntries.length > 0 && navigationEntries[0].type === 'navigate') {
            const message = this.elements.errorMsgBox.textContent.replace(/\s+/g, ' ').trim();
            const obj = {
                event: 'cart-payment-error',
                error: {
                    message: message,
                },
            };
            window.adobeDataLayer.push(obj);
        }
    };

    afterAddresVerify = () => {
        this.setElements();
        this.eventListeners();
        this.handleTooltipToggle();
    };
}
